// extracted by mini-css-extract-plugin
export default {"MarkdownViewerContainer":"MarkdownViewer-module__MarkdownViewerContainer--uzYgQ"};